"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[94378],{

/***/ 94378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96076);






var TextSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(43007)]).then(__webpack_require__.bind(__webpack_require__, 17151));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17151)
            ];
        }
    }
});
var CardsSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(2013), __webpack_require__.e(56012)]).then(__webpack_require__.bind(__webpack_require__, 90058));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90058)
            ];
        }
    }
});
var FeedbackSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(55297)]).then(__webpack_require__.bind(__webpack_require__, 43394));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43394)
            ];
        }
    }
});
var SvgListSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(94407)]).then(__webpack_require__.bind(__webpack_require__, 12076));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12076)
            ];
        }
    }
});
var ReviewsSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(8084)]).then(__webpack_require__.bind(__webpack_require__, 77359));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77359)
            ];
        }
    }
});
var Blog = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(24168), __webpack_require__.e(57330), __webpack_require__.e(15805), __webpack_require__.e(23382), __webpack_require__.e(13300)]).then(__webpack_require__.bind(__webpack_require__, 58419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58419)
            ];
        }
    }
});
var PhotoGallery = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(6778), __webpack_require__.e(15805), __webpack_require__.e(53205)]).then(__webpack_require__.bind(__webpack_require__, 39284));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39284)
            ];
        }
    }
});
var TeamSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(98885), __webpack_require__.e(61793), __webpack_require__.e(6778), __webpack_require__.e(15805), __webpack_require__.e(3667)]).then(__webpack_require__.bind(__webpack_require__, 79143));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79143)
            ];
        }
    }
});
var InfinityScrollingCarousel = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(52542)]).then(__webpack_require__.bind(__webpack_require__, 98404));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98404)
            ];
        }
    }
});
var CardsSlider = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(6778), __webpack_require__.e(15805), __webpack_require__.e(50350)]).then(__webpack_require__.bind(__webpack_require__, 35637));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35637)
            ];
        }
    }
});
var SvgList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(6778), __webpack_require__.e(15805), __webpack_require__.e(90934)]).then(__webpack_require__.bind(__webpack_require__, 15804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15804)
            ];
        }
    }
});
var Card = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(45910)]).then(__webpack_require__.bind(__webpack_require__, 45910));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45910)
            ];
        }
    }
});
var ScrollingTabs = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(18637)]).then(__webpack_require__.bind(__webpack_require__, 34479));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34479)
            ];
        }
    }
});
var Works = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(65781)]).then(__webpack_require__.bind(__webpack_require__, 80935));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80935)
            ];
        }
    }
});
var Cta = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(84602), __webpack_require__.e(6778), __webpack_require__.e(9994)]).then(__webpack_require__.bind(__webpack_require__, 9994));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9994)
            ];
        }
    },
    ssr: false
});
var YoutubeVideosSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(76116)]).then(__webpack_require__.bind(__webpack_require__, 27393));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27393)
            ];
        }
    }
});
var CaseProcess = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(6778), __webpack_require__.e(15805), __webpack_require__.e(48521), __webpack_require__.e(33030)]).then(__webpack_require__.bind(__webpack_require__, 96366));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96366)
            ];
        }
    }
});
var Images = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(83628), __webpack_require__.e(75978)]).then(__webpack_require__.bind(__webpack_require__, 53435));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53435)
            ];
        }
    }
});
var SectionSelector = function(_param) {
    var section = _param.section, type = _param.type, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "section",
        "type"
    ]);
    var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getDocumentFields */ .OA)(section, [
        "type"
    ]), sectionType = ref.type;
    switch(sectionType){
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.text */ .Ez.text:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextSection, {
                sectionData: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.cards */ .Ez.cards:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsSection, {
                section: section,
                type: type,
                sectionType: "cards"
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.cardsWithOverlay */ .Ez.cardsWithOverlay:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsSection, {
                section: section,
                type: type,
                withOverlay: true
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.svgDisplay */ .Ez.svgDisplay:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SvgListSection, {
                section: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.svgDisplayWithSelector */ .Ez.svgDisplayWithSelector:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SvgListSection, {
                section: section,
                type: type,
                withSelector: true
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.reviews */ .Ez.reviews:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewsSection, {
                section: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.blog */ .Ez.blog:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Blog, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                sectionData: section
            }, rest));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.photos */ .Ez.photos:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PhotoGallery, {
                sectionData: section
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.feedback */ .Ez.feedback:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeedbackSection, {
                section: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.team */ .Ez.team:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TeamSection, {
                data: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.infinityScrollingCarousel */ .Ez.infinityScrollingCarousel:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InfinityScrollingCarousel, {
                section: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.cardsSlider */ .Ez.cardsSlider:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsSlider, {
                section: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.svgList */ .Ez.svgList:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SvgList, {
                section: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.card */ .Ez.card:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {
                data: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.scrollingTabs */ .Ez.scrollingTabs:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollingTabs, {
                section: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.portfolio */ .Ez.portfolio:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Works, {
                section: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.cta */ .Ez.cta:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Cta, {
                section: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.caseProcess */ .Ez.caseProcess:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CaseProcess, {
                data: section === null || section === void 0 ? void 0 : section.fields,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.images */ .Ez.images:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Images, {
                data: section === null || section === void 0 ? void 0 : section.fields,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.youtubeVideos */ .Ez.youtubeVideos:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(YoutubeVideosSection, {
                section: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEPAGE_SECTION_TYPES.youtubeVideosWithSlider */ .Ez.youtubeVideosWithSlider:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(YoutubeVideosSection, {
                withSlider: true,
                section: section,
                type: type
            });
        default:
            return null;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (SectionSelector);


/***/ })

}]);